import React from 'react';
import { compare as compareObject } from '../../utils/functions';
import { AccordionItem } from '../../components/@base/Accordion';
import styles from '../../components/BotComponents/SharedStyle.module.css';
import Select from '../../components/@base/Select';
import SelectOption from '../../components/@base/SelectOption';

/**
 * Renderiza item do accordion com campo para gerenciar a localização do componente no fluxo
 *
 * Não renderiza se o fluxo estiver inválido
 * @param {*} parent ponteiro this do ComponentConfiguration
 * @returns
 */
export const LocalizationComponentAccordionItem = ({ parent }) => {
  if (!parent.props.isValidFlow || parent.props.componentSelected.notAllowedChangeLocation) {
    return <></>;
  }

  const components = Object.values(parent.props.flow).filter((e) => e.data);
  let options = components.sort((a, b) => compareObject(a, b, 'order')).map((c) => c.data.label);
  options[0] = 'Início da conversa';
  options = options.filter((e) => e !== parent.props.componentSelected.label);
  const value = parent.props.flow[parent.props.componentSelected.previous].data.label || options[0];

  const selecteOptions = options.map(
    (i) => (
      <SelectOption
        key={i}
        selected={i === value}
      >
        {i}
      </SelectOption>
    ),
  );

  const select = (
    <Select
      labelWidth={70}
      inline
      label="Depois de"
      placeholder="Selecione"
      small
      value={value}
      onChange={(e) => {
        if (e === value) return;
        const order = options.findIndex((i) => i === e);
        parent.props.changeNodeLocalizationHandler(parent.state.component.id, order);
      }}
    >
      {selecteOptions}
    </Select>
  );

  return (
    <AccordionItem>
      <span>Localização no fluxo</span>
      <div className={styles.ComponentSubList}>
        <div>
          <div />
          <div>
            {select}
          </div>
          <div />
        </div>
      </div>
    </AccordionItem>
  );
};

export default LocalizationComponentAccordionItem;
